import { render, staticRenderFns } from "./NotificacionesPersonal.vue?vue&type=template&id=6faea6de"
import script from "./NotificacionesPersonal.vue?vue&type=script&lang=js"
export * from "./NotificacionesPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports